
const MuiStyles = {
    AutoComplete: {
        width: 300,
        borderRadius: '15px',
        '& .MuiOutlinedInput-input': {
            padding: '8.5px',
            paddingRight: '6px !important'
        },
        '& .MuiOutlinedInput-notchedOutline ': {
            borderWidth: '2px',
            borderColor: '#ff0f64',
        }, 
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'gray !important', 
            color: 'gray !important'
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: 'rgb(255, 15, 100)',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderWidth: '1px',
                borderColor: 'black',
            },
        },
        "&.hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "grey !important",
            borderWidth: "1px",
        },
    },

    Select: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'grey !important', // Border color when focused
        },
        "&.hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "grey !important",
            borderWidth: "1px"
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: '#ff0f64', // Default border color
            borderWidth: '2px',         // Default border color
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: 'black',  
            borderWidth: "1px",            // Change border color on hover
        },
              
        
    }
}

export default MuiStyles